import React, { useState } from 'react';
import { connect } from 'react-redux';
import { IconButton, Checkbox } from '@mui/material';
import { Delete, Save } from '@mui/icons-material';
import { useConfirm } from 'material-ui-confirm';
import {
  updateAlertActionAC,
  removeAlertActionAC,
  createAlertActionAC,
} from '../../redux/actions/dataAlerts';
import { Row, Fill } from '../util/Page';
import ListSelector from '../util/ListSelector';
import DurationSelector from '../util/DurationSelector';
import { TypeSelector, getParamsSection } from './ActionTypes';

/* eslint-disable jsx-a11y/label-has-associated-control */

const FiringSelector = ({ selected, onChange }) => (
  <label>
    <span className="alert-label">Action fire state:</span>
    <ListSelector values={['OKAY', 'ALERT']} selected={selected} onChange={onChange} />
  </label>
);

const ActionEdit = ({ action, onChange }) => (
  <>
    <div className="alert-col">
      <FiringSelector selected={action.fire_state} onChange={(v) => onChange('fire_state', v)} />
      <div>
        <label>
          <span className="alert-label">Action enabled?</span>
          <Checkbox
            checked={action.enabled}
            onChange={(e) => onChange('enabled', e.target.checked)}
          />
        </label>
      </div>
    </div>
    <div className="alert-col">
      <TypeSelector selected={action.type} onChange={(v) => onChange('type', v)} />
      {getParamsSection(action.type, action.params, (v) => onChange('params', v))}
    </div>
    <div className="alert-col">
      <DurationSelector
        label="Firing interval"
        type="number"
        inputProps={{ min: 1 }}
        seconds={action.interval}
        onSecondsChange={(v) => onChange('interval', v)}
      />
    </div>
  </>
);

const ActionCreator = connect(null, (dispatch) => ({
  create: (alertId, action) => dispatch(createAlertActionAC(alertId, action)),
}))(({ alertId, setCreating, create }) => {
  const [action, setAction] = useState({
    type: 'email',
    params: {},
    fire_state: 'ALERT',
    enabled: true,
    interval: 24 * 60 * 60, // daily
  });
  return (
    <>
      <Row>
        <ActionEdit
          action={action}
          onChange={(k, v) => {
            setAction({ ...action, [k]: v });
            return Promise.resolve('ok');
          }}
        />
      </Row>
      <Row>
        <Fill />
        <IconButton onClick={() => setCreating(false)} size="large">
          Cancel
        </IconButton>
        <IconButton
          onClick={() => create(alertId, action).then(() => setCreating(false))}
          size="large"
        >
          Create action <Save />
        </IconButton>
      </Row>
    </>
  );
});

export { ActionCreator };

const ActionRow = ({ alertId, action, update, del }) => {
  const confirm = useConfirm();
  return (
    <Row>
      <ActionEdit
        action={action}
        onChange={(field, val) => update(alertId, action.id, { ...action, [field]: val })}
      />
      <IconButton
        onClick={() =>
          confirm({
            title: 'Please confirm deletion',
            description: 'This will permanently delete this action, and canot be undone',
            confirmationText: 'Delete action',
          })
            .then(({ confirmed }) => (confirmed ? del(alertId, action.id) : null))
            .catch(() => {})
        }
        size="large"
      >
        <Delete />
      </IconButton>
    </Row>
  );
};

export default connect(null, (dispatch) => ({
  del: (alertId, actionId) => dispatch(removeAlertActionAC(alertId, actionId)),
  update: (alertId, actionId, action) => dispatch(updateAlertActionAC(alertId, actionId, action)),
}))(ActionRow);
